$shm_showcase_preview $mol_view
	entry_id \
	Shm_paginator $shm_paginator
		total 150
	Chart $mol_chart
		gap_hor 4
		gap_vert 4
		graphs / <= Chart_line $mol_plot_line
			series_y /
				2
				5
				3
				7
				4
	Calendar_pick $mol_pick
		trigger_content / \Сентябрь
		bubble_content / <= Calendar $mol_calendar
			month_string \2026-09
	Stack $mol_stack
		sub /
			<= Stack_back $mol_avatar id \layers
			<= Stack_front $mol_speck value \✓
	Pop $mol_pop
		showed? <=> pop_opened? false
		Anchor <= Pop_toggle $mol_check_box
			title \Показать
			checked? <=> pop_opened?
		bubble_content / \Всплывающий блок
	Lights $mol_lights_toggle
	Theme $mol_card
		plugins / <= Auto_theme $mol_theme_auto
		title \Автотема
	Share $mol_button_share
		title \Поделиться
		uri \https://mol.hyoo.ru/
	File_drop $shm_file_drop
		drop_title <= file_title \Файл
		files? <=> files? /File
	Period_pick $mol_pick
		trigger_content / \Период
		bubble_content / <= Period $shm_period
			date_from? <=> period_from? \2026-09-01
			date_to? <=> period_to? \2026-09-07
	Form_pick $mol_pick
		trigger_content / \Заполнить
		bubble_content / <= Form
	Form $mol_form
		submit_title \Проверить
		message_done \Готово
		body / <= Form_field $mol_form_field
			name \Имя
			control <= Form_input $mol_string
				hint \Введите имя
	Grid $mol_grid
		records *
			a *
				Товар \Чай
				Шт 2
	Search $mol_search
		hint \Найти
	Textarea $mol_textarea
		value? <=> textarea_value? \
			\Первая
			\Вторая
	Checks $mol_check_list
		dictionary? <=> checks_value? *
			a true
			b false
		options *
			a \А
			b \Б
	Shm_checks $shm_check_list
		options /
			\А
			\Б
	Multiple $mol_select_list
		value? <=> multiple_value? / \a
		dictionary *
			a \А
			b \Б
	Section $mol_section
		title \Секция
		content / <= First
	Toolbar $mol_toolbar
		items /
			<= Action_a
			<= Action_b
	Deck $mol_deck
		current? <=> deck_current? \0
		items /
			<= Tab_a $mol_view
				title \А
				sub / \Первая
			<= Tab_b $mol_view
				title \Б
				sub / \Вторая
	Gallery $mol_gallery
		items /
			<= Action_a
			<= Action_b
	Scroll $mol_scroll
		sub /
			<= Scroll_content $mol_list
				rows /
					<= Text
					<= Code
					<= Items
	Frame $mol_frame
		html \<!doctype html><html lang="ru"><body>Iframe</body></html>
	Echarts $shm_echarts
		animation_duration_initial 0
		animation_duration_update 0
		option <= chart_option null
	sub <= content /
	Text $mol_text
		text \Текст **Markdown**
	Speck $mol_speck
		value \Метка
	Avatar $mol_avatar
		id \showcase
	Portion $mol_portion
		portion 0.6
	Check $mol_check_box
		checked? <=> checked? true
	String $mol_string
		hint \Текст
	Button $mol_button_minor
		title \Кнопка
	Loader $shm_dotsloader
	Code $mol_text_code
		text \const n = 1
	Number $mol_number
		value? <=> number_value? 7
	Switch $mol_switch
		value? <=> switch_value? \a
		options *
			a \А
			b \Б
	Select $mol_select
		value? <=> select_value? \a
		dictionary *
			a \Первый
			b \Второй
	Date $mol_date
		value? <=> date_value? \2026-09-06
	Time $mol_pick_time
		value? <=> time_value? \12:30
	Format $mol_format
		mask* \___-___
		value? <=> format_value? \123456
	Paginator $mol_paginator
		value? <=> page_value? 1
	Link $mol_link
		title \Ссылка
		arg * component \link
	Pick $mol_pick
		trigger_content / \Выбрать
		bubble_content / \Содержимое
	Hover $mol_pop_over
		Anchor <= Hover_anchor $mol_button_minor
			title \Наведи
		bubble_content / \Подсказка
	Expander $mol_expander
		title \Подробнее
		content / \Содержимое
	Labeler $mol_labeler
		title \Подпись
		content / \Значение
	Card $mol_card
		title \Карточка
		status \Готово
	List $mol_list
		rows /
			<= First
			<= Second
	Bar $mol_bar
		sub /
			<= Action_a $mol_button_minor title \А
			<= Action_b $mol_button_minor title \Б
	Items $mol_view
		sub /
			<= First $mol_view sub / \А
			<= Second $mol_view sub / \Б
			<= Third $mol_view sub / \В
